import script from "./GameCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameCards.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__